import { useEffect, useState } from "react";

/** Whether a window of the app is on screen. Live clocks tick only while it is: a backgrounded
 *  tab throttles timers anyway, and the counter app's invisible bridge flickers this on every
 *  ping, which is why callers debounce what they do with it. */
export function useDocumentVisible(): boolean {
  const [visible, setVisible] = useState(() => document.visibilityState !== "hidden");
  useEffect(() => {
    const on = () => setVisible(document.visibilityState !== "hidden");
    document.addEventListener("visibilitychange", on);
    return () => document.removeEventListener("visibilitychange", on);
  }, []);
  return visible;
}
